// Entry for pages without their own module script: applies the signed-in
// account's market remembered on this device (see services/market.js), and
// hides links to the website's pricing pages inside the Android app (see
// services/purchase.js).
import './services/market.js';
import { showsWebPricing } from './services/purchase.js';

if (!showsWebPricing()) {
    document.querySelectorAll('.web-pricing-link, .purchase-prompt').forEach((el) => { el.style.display = 'none'; });
}
